import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { LayoutModule } from '@angular/cdk/layout';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ProfileAvatarComponent } from './profile-avatar/profile-avatar.component';
import { ProfileLogoComponent } from './profile-logo/profile-logo.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShipmentModule } from '../shipment/shipment.module';
import { JournalComponent } from './journal/journal.component';
import { MaterialModule } from '../material/material.module';
import { ActionIndicatorComponent } from './action-indicator/action-indicator.component';
import { ActionActivityComponent } from './action-activity/action-activity.component';
import { DocumentIndicatorComponent } from './document-indicator/document-indicator.component';
import { AddressBookModule } from '../address-books/address-book.module';
import { ExportComponent } from './export/export.component';
import { CreateEntityButtonComponent } from './create-entity-button/create-entity-button.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { FabExpandComponent } from './fab-expand/fab-expand.component';
import { TopToolbarComponent } from './top-toolbar/top-toolbar.component';

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        FontAwesomeModule,
        ShipmentModule,
        MaterialModule,
        AddressBookModule,
        FabExpandComponent,
        LayoutComponent,
        ProfileAvatarComponent,
        ProfileLogoComponent,
        JournalComponent,
        ActionIndicatorComponent,
        ActionActivityComponent,
        DocumentIndicatorComponent,
        ExportComponent,
        CreateEntityButtonComponent,
        SideMenuComponent,
        TopToolbarComponent
    ],
    exports: [
        ProfileAvatarComponent,
        DocumentIndicatorComponent
    ]
})
export class NavigationModule {
}
